import reactStringReplace from 'react-string-replace';

import { cn } from '@/shadcn/lib/utils';

import { PROSE_REGEX_MARKDOWN_BOLD } from './constants.prose';

type Props = {
  items: string[];
  small?: boolean;
  ordered?: boolean;
  className?: string;
};

export const ProseList = ({
  items,
  small = false,
  ordered = false,
  className
}: Props) => {
  const parseBoldMarkdown = item =>
    reactStringReplace(item, PROSE_REGEX_MARKDOWN_BOLD, (match, i) => (
      <strong key={`bold_${i}`}>{match}</strong>
    ));

  const renderItems = () =>
    items.map((item, i) => (
      <li className="mb-[3px] [&>strong]:font-semibold" key={`item_${i}`}>
        {parseBoldMarkdown(item)}
      </li>
    ));

  const Component = ordered ? 'ol' : 'ul';
  return (
    <Component
      className={cn(
        'pl-4 text-sm',
        ordered ? 'list-decimal' : 'list-disc',
        small && 'text-xs',
        className
      )}
    >
      {renderItems()}
    </Component>
  );
};
